import { Box, Grid, Stack, useTheme } from "@mui/material";
import React, { useEffect } from "react";
import { ShadowContainer } from "../../components/componentLayout/ComponentLayout";
import DataGridFunction from "../../components/datagridComponent/datagrid";
import { connect } from "react-redux";
import { selectRequesting } from "../../selectors/requesting/RequestingSelector";
import InfluencersCampaignsAction from "../../stores/influencersCampaigns/InfluencersCampaignsAction";
import InfluencersActivityAction from "../../stores/influencersActivity/InfluencersActivityAction";
import InfluencerDashboardAction from "../../stores/influencerDashboard/InfluencerDashboardAction";
import { Line } from "react-chartjs-2";
import { useLocation, useNavigate } from "react-router";

const mapStateToProps = (state) => ({
  isRequesting: selectRequesting(state, [
    InfluencersCampaignsAction.REQUEST_INFLUENCERS_CAMPAIGNS,
    InfluencersActivityAction.REQUEST_INFLUENCERS_ACTIVITY_FILTER,
    InfluencerDashboardAction.REQUEST_INFLUENCER_DASHBOARD,
    InfluencersCampaignsAction.REQUEST_INFLUENCERS_CAMPAIGNS_FILTER,
  ]),
  influencersCampaignFilter:
    state.influencersCampaignFilter.influencersCampaignFilter || [],
  influencersActivityFilter:
    state.influencersActivityFilter.influencersActivityFilter || [],
  influencerDashboard: state.influencerDashboard.influencerDashboard || [],
  influencersCampaign: state.influencersCampaign.influencersCampaign || [],
});

const InfluencerDashboard = (props) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    let params = {
      order_by: [["created_on", "asc"]],
      page_limit: 5,
    };

    fetchCampaigns(params);
    fetchInfluencerActivities(params);
    fetchAllCampaigns({ page_limit: "none" });

    let param = {
      hit_list_count: 5,
    };
    // fetchInfluencerDashboard(param);
  }, []);

  function fetchCampaigns(params) {
    props.dispatch(
      InfluencersCampaignsAction.requestInfluencerCampaigns(params)
    );
  }

  function fetchAllCampaigns(params) {
    props.dispatch(InfluencersCampaignsAction.requestInfluencersFilter(params));
  }

  function fetchInfluencerActivities(params) {
    props.dispatch(
      InfluencersActivityAction.requestInfluencersActivityFilter(params)
    );
  }

  // function fetchInfluencerDashboard(params) {
  //   props.dispatch(
  //     InfluencerDashboardAction.requestInfluencerDashboard(params)
  //   );
  // }

  let allCampaigns = [];
  props.influencersCampaignFilter &&
    props.influencersCampaignFilter.hits &&
    props.influencersCampaignFilter.hits.hits.map((item, index) =>
      allCampaigns.push({
        campaignId: item._id,
        campaignName: item._source.campaign_name,
      })
    );

  function returnCampaignName(campaignID) {
    let filteredCampaign = allCampaigns.filter(
      (item) => item.campaignId === campaignID
    );

    return filteredCampaign && filteredCampaign[0]
      ? filteredCampaign[0].campaignName
      : "---";
  }

  let CampaignsArray = [];

  props.influencersCampaign &&
    props.influencersCampaign.hits &&
    props.influencersCampaign.hits.hits &&
    props.influencersCampaign.hits.hits.map((item, index) =>
      CampaignsArray.push({
        id: item._id,
        slno: item._id
          ? props.influencersCampaign.current_page_no * 10 + ++index
          : "",
        name: item._source.campaign_name,
      })
    );

  const campaignsColumns = [
    {
      field: "slno",
      headerName: "SL NO",
      width: 100,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "name",
      headerName: "Campaign Name",
      flex: 1,
      align: "center",
      headerAlign: "center",
    },
  ];

  let activitiesArray = [];

  props.influencersActivityFilter &&
    props.influencersActivityFilter.hits &&
    props.influencersActivityFilter.hits.hits.map((item, index) =>
      activitiesArray.push({
        id: item._id,
        slno: item._id
          ? props.influencersActivityFilter.current_page_no * 10 + ++index
          : "",
        name: item._source.activity_name,
      })
    );

  const activitiesColumns = [
    {
      field: "slno",
      headerName: "SL NO",
      width: 100,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "name",
      headerName: "Activities Name",
      flex: 1,
      align: "center",
      headerAlign: "center",
    },
  ];

  let CountArray = [];
  let chartState = {
    labels: [],
    datasets: [
      {
        type: "bar",
        backgroundColor: "lightblue",
        label: "Activity",
        yAxisID: "y",
        data: [],
      },
    ],
  };

  props.influencerDashboard &&
    props.influencerDashboard.data &&
    props.influencerDashboard.data.length > 0 &&
    props.influencerDashboard.data.map((item, index) => {
      return (
        CountArray.push({
          id: index,
          name: item.key,
          count: item.count,
        }),
        chartState.labels.push(returnCampaignName(item.key)),
        chartState.datasets[0].data.push(item.count)
      );
    });

  return (
    <Box mr={2}>
      <Stack direction={"column"} spacing={1}>
        <ShadowContainer
          sx={{ marginBottom: 5, padding: 0, borderRadius: "8px" }}
        >
          {/******************************** my campaign *********************************  */}
          <Grid container item lg={12} laptop={12} md={12} sm={12}>
            <Grid
              container
              item
              xl={6}
              lg={6}
              laptop={6}
              md={6}
              sm={12}
              display="flex"
              justifyContent="start"
              flexDirection="column"
              alignSelf="center"
              p={1}
              marginTop="10px"
              // className="bg-warning"
            >
              <Grid
                item
                lg={12}
                laptop={12}
                md={12}
                sm={12}
                textAlign="left"
                fontSize="24px"
                pl={2}
                // className="bg-success"
              >
                <p
                  style={{
                    fontSize: theme.typography.h2.fontSize,
                  }}
                >
                  <span className="firstLetter">M</span>y&nbsp;
                  <span className="firstLetter">C</span>ampaign
                </p>
              </Grid>
              <Grid
                container
                item
                lg={12}
                laptop={12}
                md={12}
                sm={12}
                paddingBottom={1}
                justifyContent="space-evenly"
                alignItems="center"
                rowGap={1}
                paddingLeft={2}
                display="-webkit-box"
                // className="bg-warning"
              >
                <Grid lg={8} md={8} sm={8}>
                  <DataGridFunction
                    rowHeight={60}
                    height={280}
                    rows={CampaignsArray}
                    columns={campaignsColumns}
                    curser={"pointer"}
                    onRowClick={(params) => {
                      navigate(`/InfluencersAllActivity`, {
                        state: {
                          campaign_id: params.row.id,
                          campaign_name: params.row.name,
                          from: location.pathname,
                        },
                      });
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid
              container
              item
              xl={6}
              lg={6}
              laptop={6}
              md={6}
              sm={12}
              display="flex"
              justifyContent="start"
              flexDirection="column"
              alignSelf="center"
              p={1}
              marginTop="10px"
              // className="bg-warning"
            >
              <Grid
                lg={12}
                sm={12}
                md={12}
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  flexDirection: "column",
                }}
              >
                <Grid
                  item
                  lg={12}
                  laptop={12}
                  md={6}
                  sm={12}
                  textAlign="left"
                  pl={2}
                >
                  <p style={{ fontSize: theme.typography.h2.fontSize }}>
                    <span className="firstLetter">M</span>y&nbsp;
                    <span className="firstLetter">A</span>ctivities&nbsp;
                  </p>
                </Grid>
              </Grid>

              <Grid
                container
                item
                lg={12}
                laptop={12}
                md={12}
                sm={12}
                paddingBottom={1}
                justifyContent="space-evenly"
                alignItems="center"
                rowGap={1}
                paddingLeft={2}
                display="-webkit-box"
                // className="bg-warning"
              >
                <Grid lg={8} md={8} sm={8}>
                  <DataGridFunction
                    rowHeight={60}
                    height={280}
                    rows={activitiesArray}
                    columns={activitiesColumns}
                  />
                </Grid>
              </Grid>
            </Grid>

            {/* <hr style={{ width: "100%", marginTop: 10, marginBottom: 30 }} /> */}

            {/******************************** my campaign list *********************************  */}
          </Grid>

          {/* ******************************* count list ****************************** */}

          <Grid
            className="NetPromoterScoreBox"
            item
            container
            lg={12}
            laptop={12}
            md={12}
            sm={12}
            mt={4}
          >
            {/* <hr style={{ width: "100%", marginTop: 30, marginBottom: 10 }} /> */}
            {/******************************** my activities per count *********************************  */}
            {/* <Grid item container lg={6} laptop={6} md={6} sm={12}>
              <Grid
                item
                lg={12}
                laptop={12}
                md={12}
                sm={12}
                textAlign="left"
                p={1}
              >
                <p
                  style={{
                    fontSize: theme.typography.h2.fontSize,
                    paddingLeft: 16,
                  }}
                >
                  <span className="firstLetter">M</span>y&nbsp;
                  <span className="firstLetter">A</span>ctivity&nbsp;
                  <span className="firstLetter">C</span>ount&nbsp;
                  <span className="firstLetter">P</span>er&nbsp;
                  <span className="firstLetter">C</span>ampaign&nbsp;
                </p>
              </Grid>

              <Grid
                container
                item
                lg={12}
                laptop={12}
                md={12}
                sm={12}
                paddingBottom={1}
                justifyContent="space-evenly"
                alignItems="center"
                rowGap={1}
                display="-webkit-box"
              >
                {CountArray.map((item) => (
                  <Grid
                    container
                    sx={{
                      backgroundColor: "transparent",
                      textAlign: "inherit",
                      padding: "none",
                      margin: 1.5,
                    }}
                    onClick={() => {}}
                    item
                    lg={2.5}
                    md={2.5}
                    sm={2.5}
                    className="TicketBox text-wrap"
                  >
                    <Grid item container lg={12} laptop={12} md={12} sm={12}>
                      <Grid
                        item
                        lg={12}
                        laptop={12}
                        md={12}
                        sm={12}
                        alignSelf="flex-end"
                      >
                        <span>{returnCampaignName(item.name)}</span>
                      </Grid>
                      <Grid
                        item
                        lg={12}
                        laptop={12}
                        md={12}
                        sm={12}
                        alignSelf="center"
                      >
                        <span>{item.count}</span>
                      </Grid>
                    </Grid>
                  </Grid>
                ))}
              </Grid>
            </Grid> */}
            {/* <Grid item container lg={6} laptop={6} md={6} sm={12}>
              <Grid
                item
                lg={12}
                laptop={12}
                md={12}
                sm={12}
                textAlign="left"
                p={1}
              >
                <Grid
                  container
                  item
                  lg={12}
                  laptop={12}
                  md={12}
                  sm={12}
                  paddingBottom={1}
                  justifyContent="space-evenly"
                  alignItems="center"
                  rowGap={1}
                  display="-webkit-box"
                >
                  <Grid
                    className="NetPromoterScoreBox"
                    item
                    container
                    lg={12}
                    laptop={12}
                    md={12}
                    sm={12}
                  >
                    <Grid
                      sx={{
                        width: "100%",
                        padding: "50px",
                        height: 500,
                      }}
                    >
                      <Line
                        datasetIdKey="id"
                        data={chartState}
                        options={{
                          responsive: true,
                          maintainAspectRatio: false,
                          plugins: {
                            tooltip: {
                              usePointStyle: true,
                            },
                            legend: {
                              display: true,
                              position: "bottom",
                            },
                          },
                          scales: {
                            x: {
                              max: 100,
                              min: 0,
                              ticks: {
                                stepSize: 10,
                              },
                              grid: {
                                display: false,
                              },
                              title: {
                                text: "Campaign",
                                display: true,
                                color: "black",
                              },
                            },
                            y: {
                              max:
                                chartState.datasets &&
                                chartState.datasets[0].data &&
                                Math.max(...chartState.datasets[0].data) + 5,
                              min: 0,
                              ticks: {
                                stepSize: 5,
                              },
                              title: {
                                display: true,
                                text: "Activity Count",
                              },
                              grid: {
                                display: true,
                              },
                            },
                          },
                        }}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid> */}
          </Grid>

          {/******************************** Line Chart  *********************************  */}
        </ShadowContainer>
      </Stack>
    </Box>
  );
};

export default connect(mapStateToProps)(InfluencerDashboard);
